module.exports = __webpack_public_path__ + "static/media/dogecoin-doge-logo.bfe942ea.svg";